export default __webpack_public_path__ + "static/media/hht2_ep16_speaking_03.6674e491.png";